import React, { Fragment, ReactElement } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { normalizeNameOfPerson } from '../../../../../../utils/normalize/normalizeNameOfPerson';

// Types

import { SocialSecurityCard } from '../../../../../../components/ssap/SsapTypes';

interface SsnInfo extends SocialSecurityCard {
    idx: number
}


const SsnInfo = (props: SsnInfo): ReactElement => {
    
    const {
        idx,
        firstNameOnSSNCard,
        lastNameOnSSNCard,
        middleNameOnSSNCard,
        nameSameOnSSNCardIndicator,
        socialSecurityCardHolderIndicator,
        socialSecurityNumber,
        suffixOnSSNCard
    } = props;

    const NameOnSSNCard = {
        firstName: firstNameOnSSNCard,
        lastName: lastNameOnSSNCard,
        middleName: middleNameOnSSNCard,
        suffix: suffixOnSSNCard
    };

    const getBoolean = value => !!value;
    const getNameOnSsnCard = (...args) => {
        const [
            firstName,
            lastName,
            middleName,
            suffix
        ] = args;

        return args.every(v => !v)
            ? 'common.no_text'
            : normalizeNameOfPerson({
                firstName,
                lastName,
                middleName,
                suffix
            });
    };
    
    return (
        <Fragment>
            <SummaryItem
                textCode = 'common.have_ssn'
                value = { !!socialSecurityNumber }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].socialSecurityCard.socialSecurityNumber`,
                            getBoolean
                        ]
                    ]
                }
            />

            {
                !!socialSecurityNumber &&

                <SummaryItem
                    textCode = 'common.ssn'
                    value = { socialSecurityNumber }
                    ignoreIntl
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].socialSecurityCard.socialSecurityNumber`
                            ]
                        ]
                    }
                />
            }

            {
                socialSecurityCardHolderIndicator && (
                    <Fragment>
                        <SummaryItem
                            textCode = 'common.name_on_ssn_the_same'
                            value = { nameSameOnSSNCardIndicator }
                            desc = {
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].socialSecurityCard.nameSameOnSSNCardIndicator`
                                    ]
                                ]
                            }
                        />

                        {
                            !nameSameOnSSNCardIndicator &&

                            <SummaryItem
                                textCode = 'common.name_as_shown_on_ssn'
                                value = { normalizeNameOfPerson(NameOnSSNCard) }
                                ignoreIntl
                                desc = {
                                    [
                                        [
                                            [
                                                `taxHousehold.householdMember[${ idx }].socialSecurityCard.firstNameOnSSNCard`,
                                                `taxHousehold.householdMember[${ idx }].socialSecurityCard.lastNameOnSSNCard`,
                                                `taxHousehold.householdMember[${ idx }].socialSecurityCard.middleNameOnSSNCard`,
                                                `taxHousehold.householdMember[${ idx }].socialSecurityCard.suffixOnSSNCard`,
                                            ],
                                            getNameOnSsnCard
                                        ]
                                    ]
                                }
                            />

                        }
                    </Fragment>
                )
            }
        </Fragment>
    );
};

export default SsnInfo;